import { useQuery } from "@tanstack/react-query"

import { GetMarkedWallsGPS } from "@/types/sharedTypes"
import { trpcOptions } from "@/utils/trpc"

export const getMarkedWallsOptions = (sessionId: string, gps: GetMarkedWallsGPS, forcePointOutsidePolygon?: boolean) =>
  // Prevents undefined and false from creating two cache entries for the same request
  trpcOptions.sessions.getMarkedWalls.queryOptions({
    sessionId,
    gps,
    forcePointOutsidePolygon: forcePointOutsidePolygon ?? false,
  })

export function useGetMarkedWalls(sessionId: string, gps: GetMarkedWallsGPS, forcePointOutsidePolygon?: boolean) {
  return useQuery(getMarkedWallsOptions(sessionId, gps, forcePointOutsidePolygon))
}
